import React from 'react';
import { ReactSVG } from "react-svg";
import i18n from '../../i18n/i18n.js';
import { Link  } from "react-router-dom";
import { Utils } from '../../Utils';

import './NewsletterSubscribe.css';

class NewsletterSubscribe extends React.Component {

  emptyFormData = {
    email: '',
  };

  emptyFormErrors = {
    email: '',
  };

  emptyFormSuccess = {
    email: '',
  };

  constructor(props) {
      super(props);

      this.state = {
        formData: { email: window?.AppRef?.current?.state?.user_data?.email },
        formErrors: { ...this.emptyFormErrors },
        formSuccess: { ...this.emptyFormSuccess },
      };
  }

  handle_submit(e) {
    e.preventDefault();

    const formErrors = this.state.formErrors;

    Utils.get_server_data(
      '',
      {
        ajax_event:'newsletter_subscribe',
        APICACHE:'false'
      }, 
      {
        ajax_event: 'newsletter_subscribe',
        formData: JSON.stringify(this.state.formData),
      }
    )
    .then((res)=>{
      if (!res.subscribed_to_newsletter)
      {
        formErrors.email = i18n.t("newsletterSubcribeError");
      }
      else {
        formErrors.email = i18n.t("newsletterSubcribeSuccess");
      }

      window.AppRef.current.setState({subscribed_to_newsletter: res.subscribed_to_newsletter}, () => {
        this.setState({formErrors});   
      });
    });
  }

  handle_change(event, formDataKey, force_value = null) {
    const formData = this.state.formData;
    const formErrors = this.state.formErrors;

    formData[formDataKey] = force_value !== null ? force_value : event.target.value;
    formErrors.email = "";

    this.setState({formData, formErrors});
  }

  render() {
    const {formData, formErrors, formSuccess } = this.state;

    /* HÍRLEVÉL IDEIGLENESEN DIREKT KIKAPCSOLVA */
    //return '';
    
    const display = window.AppRef.current.get_is_signed() && parseInt(window.AppRef.current.state.subscribed_to_newsletter) == 0;

    return display ? (<div className="newsletter_subscribe">
        
        <ReactSVG className="icon" src={`assets/images/newsletter.svg`} />
        <h3>{i18n.t("newsletterSubcribeTitle")}</h3>
        <div className="text">{i18n.t("newsletterSubcribeText")}</div>

        <form onSubmit={(e) => this.handle_submit(e)}>
          <div className={`field ${formErrors.email !== '' ? "error" : ""}`}>
              <input type="email" placeholder={i18n.t("newsletterSubcribeEmail")} value={formData.email} onChange={(e) => this.handle_change(e, 'email')} /> 
              {(formErrors.email.length) ? <div className="form_error" dangerouslySetInnerHTML={{__html: formErrors.email}}></div> : '' }
              {(formSuccess.email.length) ? <div className="form_error" dangerouslySetInnerHTML={{__html: formSuccess.email}}></div> : '' }
          </div>

          <button className="button" type="sumbit">{i18n.t("newsletterSubcribeSubmit")}</button>
        </form>
        
    </div>) : '';
  }
}

export default NewsletterSubscribe;

